<template>
  <div class="consluatationCount">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>统计分析</el-breadcrumb-item>
          <el-breadcrumb-item>查房统计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>查房统计</h3>
    </div>
    <div class="table-content">
      <div class="tool-bar">
        <span>关键字：</span>
        <el-input v-model="keyword"
                  size="small"
                  placeholder="请输入医生姓名/工号"
                  width="264"
                  class="key-word"></el-input>
        <span>年份/月份:</span>
        <el-select size="small"
                   v-model="date"
                   class="date"
                   clearable
                   placeholder="请选择">
          <el-option v-for="item in dateList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-button class="search"
                   type="primary"
                   size="small"
                   @click="search">查询</el-button>
        <el-button size="small"
                   @click="reset">重置</el-button>
      </div>
      <div class="table">
        <template>
          <el-table :data="tableData"
                    style="width: 100%"
                    border>
            <el-table-column label="申请科室"
                             prop="appleDept"
                             fixed>
            </el-table-column>
            <el-table-column align="right"
                             width="160">
              <template slot="header">
                <!-- <el-input v-model="search" size="mini" placeholder="输入关键字搜索" /> -->
                <el-select size="small"
                           v-model="date"
                           class="date"
                           clearable
                           placeholder="申请医生">
                  <el-option v-for="item in dateList"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </template>
              <template slot-scope="scope">
                <span style="text-align:left;display:inline-block;width:100%;text-indent:18px">{{scope.row.appleDoctor}}</span>
              </template>
            </el-table-column>
            <el-table-column label="申请时间"
                             prop="appleDate"
                             width="150">
            </el-table-column>
            <el-table-column label="病人姓名"
                             prop="patientName">
            </el-table-column>
            <el-table-column label="病人性别"
                             prop="patientSex">
            </el-table-column>
            <el-table-column label="病人年龄"
                             prop="patientAge">
            </el-table-column>
            <el-table-column label="身份证号"
                             prop="patientIDNumber">
            </el-table-column>
            <el-table-column label="病人电话"
                             prop="patientTel">
            </el-table-column>
            <el-table-column label="初诊诊断"
                             prop="firstVisit">
            </el-table-column>
            <el-table-column label="会诊时间"
                             prop="diagnosis"
                             width="150">
            </el-table-column>
            <el-table-column label="申请类别"
                             prop="applyType">
            </el-table-column>
            <el-table-column label="会诊科室"
                             prop="diagnosisDept">
            </el-table-column>
            <el-table-column label="会诊医师姓名"
                             prop="diagnosisDoctor">
            </el-table-column>
            <el-table-column label="会诊医师工号"
                             prop="diagnosisWorkNum">
            </el-table-column>
            <el-table-column label="职称"
                             prop="diagnosisProfessional">
            </el-table-column>
            <el-table-column label="会诊后诊断"
                             prop="nextDiagnosis"
                             width="200">
            </el-table-column>
            <el-table-column label="计费"
                             prop="charging">
            </el-table-column>
            <el-table-column label="是否转院"
                             prop="transfer">
            </el-table-column>
            <el-table-column label="转院时间"
                             prop="transferDate"
                             width="150">
            </el-table-column>
          </el-table>
        </template>
      </div>
      <div class="page">
        <el-pagination @size-change='handleSizeChange'
                       @current-change='handleCurrentChange'
                       :current-page.sync='pageIndex'
                       :page-sizes='[10, 20, 50]'
                       :page-size='pageSize'
                       layout='total, sizes, prev, pager, next, jumper'
                       :total='total'>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import isShowButton from "@/mixins";
export default {
  mixins: [isShowButton],
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      isCompleted: false,
      keyword: "",
      date: "",
      dateList: [
        {
          label: "一月",
          value: "1"
        }
      ],
      tableData: [
        {
          appleDept: "申请科室",
          appleDoctor: "申请医生",
          appleDate: "申请时间",
          patientName: "病人姓名",
          patientAge: "病人年龄",
          patientSex: "病人性别",
          patientIDNumber: "身份证号",
          patientTel: "病人电话",
          firstVisit: "初步诊断",
          diagnosis: "2019-01-01 12:12:22",
          applyType: "申请类别",
          diagnosisDept: "会诊科室",
          diagnosisDoctor: "会诊医生姓名",
          diagnosisWorkNum: "会诊医师工号",
          diagnosisProfessional: "职称",
          nextDiagnosis: "会诊后诊断",
          charging: "计费",
          transfer: "是否转院",
          transferDate: "转院时间"
        }
      ]
    };
  },
  created() {
    this.getTableData(1, 10);
  },
  methods: {
    search() {
      this.getTableData(this.pageIndex, this.pageSize, this.keyword);
    },
    reset() {
      this.getTableData(1, this.pageSize);
    },
    handleSizeChange(pagesize) {
      this.pageSize = pagesize;
      this.getTableData(this.pageIndex, pagesize);
    },
    handleCurrentChange(start) {
      this.pageIndex = start;
      this.getTableData(start, this.pageSize);
    },
    getTableData(start, pagesize, keyword, date) {
      let params = {
        start: start,
        pagesize: pagesize
      }
      if (keyword != undefined) {
        params.keyword = keyword;
      }
      if (date != undefined) {
        params.date = date;
      }
      this.Axios.get("/api/Statistics/Consultation", { params })
        .then(res => {
          const data = res.data;
          if (data.status == 100) {
            this.tableData = data.data;
            this.total = data.total;
          } else {
            this.$message({
              showClose: true,
              message: data.message,
              type: "error"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="less">
.consluatationCount {
  .table-info {
    .breadcrumb {
      overflow: hidden;
      span,
      .el-breadcrumb {
        float: left;
      }
      span {
        font-size: 14px;
        color: #666;
        line-height: 1;
      }
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      .search {
        span {
          color: white;
        }
      }
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .date {
        width: 264px;
        margin-right: 20px;
      }
    }
    .table {
      margin-top: 40px;
    }
    .page {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Statistics/RoundCount.vue